/**
 * Phase 3.1 — Dentition mode auto-detect.
 *
 * Pure function. Maps patient age (years) to one of:
 *   'pediatric' | 'mixed' | 'adult'
 *
 * Boundaries follow standard Indian dental practice:
 *   ≤ 6  → primary teeth still dominant
 *   7–12 → mixed dentition (some primary, some permanent)
 *   ≥ 13 → permanent dentition
 *
 * Null / undefined / non-numeric age → 'adult' (safest default for
 * walk-in adults whose age may not be on the visit row).
 */
export function defaultDentition(age) {
  if (age == null) return 'adult';
  const n = Number(age);
  if (!Number.isFinite(n)) return 'adult';
  if (n <= 6) return 'pediatric';
  if (n <= 12) return 'mixed';
  return 'adult';
}

/**
 * Map FDI number → tooth type.
 *   incisor:   11 12 21 22 31 32 41 42  +  primary 51 52 61 62 71 72 81 82
 *   canine:    13 23 33 43               +  primary 53 63 73 83
 *   premolar:  14 15 24 25 34 35 44 45   (no primary premolars)
 *   molar:     16 17 18 26 27 28 36 37 38 46 47 48
 *              + primary 54 55 64 65 74 75 84 85 (treated as molar shape)
 */
export function toothTypeFor(fdi) {
  if (!fdi || fdi.length !== 2) return 'molar';
  const q = fdi[0];
  const n = fdi[1];
  if (q >= '1' && q <= '4') {
    if (n === '1' || n === '2') return 'incisor';
    if (n === '3') return 'canine';
    if (n === '4' || n === '5') return 'premolar';
    return 'molar';
  }
  if (q >= '5' && q <= '8') {
    if (n === '1' || n === '2') return 'incisor';
    if (n === '3') return 'canine';
    if (n === '4' || n === '5') return 'molar';
    return 'molar';
  }
  return 'molar';
}

export default defaultDentition;
